interface Option {
  value: any;
  label: string;
}

function injectOptionsLib(items: Options[], map: Map<string, Options >) {
  items.forEach(item => {
    const key = item.mapKey
    map.set(key, item)
  })
}

class Options {
  static lib = new Map()
  static injectOptionsLib = injectOptionsLib
  static use = (mapKey: string): Options => {
    if (Options.lib.has(mapKey)) {
      return Options.lib.get(mapKey)
    }
    const newOptions = new Options().useUrl()
    newOptions.mapKey = mapKey
    return newOptions
  }

  public mapKey: any = ''
  public options: Option[] = []
  public defaultLabel: any = ''

  private _prefix = ''
  private _optionsMap: Map<any, Option> = new Map()
  private _option: Option = { value: '', label: '' }

  public _useUrl = false
  public _name = ''

  constructor(options: Option[] | string = '') {
    if (typeof options === 'string') {
      this._prefix = options
    }
    this.options = typeof options === 'string' ? [] : [...options]

    this._option = this.options[this.options.length - 1]
    this.options.forEach(item => {
      this._optionsMap.set(item.value, item)
    })
  }

  private addOptionsMap() {
    if (!this._option) return
    this._optionsMap.set(this._option.value, this._option)
  }

  name(name: string) {
    this._name = name
    return this
  }

  useUrl(useUrl = true) {
    this._useUrl = useUrl
    return this
  }

  add(value: string | number, label: string) {
    if (!value && value !== 0) return this
    this._option = { value, label: '' }
    this.options.push(this._option)
    this.label(label)
    this.addOptionsMap()
    return this
  }

  value(value: any) {
    if (!value) return this
    const oldValue = this._option.value
    if (oldValue) this._optionsMap.delete(oldValue)
    this._option.value = value
    this.addOptionsMap()
    return this
  }

  label(label: string) {
    this._option.label = this._prefix && label.indexOf('.') === -1 ? `${this._prefix}.${label}` : label
    return this
  }

  default(defaultLabel: string) {
    if (!defaultLabel) return this
    this.defaultLabel = this._prefix && defaultLabel.indexOf('.') === -1 ? `${this._prefix}.${defaultLabel}` : defaultLabel
    return this
  }

  exec(value: string) {
    if (this._optionsMap.has(value)) {
      const option = this._optionsMap.get(value)
      return option && option.label
    }
    return this.defaultLabel || ''
  }
}

export default Options
